import config from '../config';

export default {
  info: (message) => (config.LOG_LEVEL === 'INFO' ? console.log(message) : null),
  debug: (message) =>
    !config.ENV.IS_PRODUCTION && config.LOG_LEVEL === 'DEBUG' ? console.log(message) : null,
};
